import { NTB_JOURNEY, PRE_ASSESSED_JOURNEY, EXISTING_JOURNEY } from 'constants/general';

import {
  YOUR_LOAN_APPROVAL,
  CHECKING_YOUR_IDENTITY,
  CONGRATULATIONS,
  ERROR,
  CREDIT_CHECK_DECLINE,
  ID_CHECK_CAN_NOT_DONE,
  CREDIT_CHECK_REFERRED,
  CREDIT_CHECK_REFERRED_NO_MATCH,
  CREDIT_CHECK_REFERRED_BANK_CHECK,
  CONFIRM_AUTH_CODE,
  CREDIT_CHECK_REFERRED_POI,
  CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
  DOCUMENTS_ON_WAY,
  CONFIRM_CODE,
  YOUR_LOAN_OPTIONS,
  INFORM_CHOICE,
  JOINT_APPLICATION_SUBMISSION,
  SUBMISSION_HOLDING_SCREEN,
  NTB_DIP_DECLARATION_AND_AUTHORISATION,
  NTB_DIP_IDV_DECLINE,
  NTB_DIP_KEEPING_YOU_SAFE,
  POST_DIP_REVIEW_DETAIL
} from 'constants/paths';

/* get Next task API response return the following id and Url.
     uri will give idea of reason of success and failure.
     routPath will be map path of action for response task id/uri.
  */
const taskUrls = [
  {
    id: 'TSK-01',
    uri: 'task://lsap/capture?caseId={ReferenceID}',
    routePath: {
      [NTB_JOURNEY]: POST_DIP_REVIEW_DETAIL
    }
  },
  {
    id: 'TSK-02',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=idcheckcannotbedone',
    routePath: {
      [NTB_JOURNEY]: ID_CHECK_CAN_NOT_DONE,
      [PRE_ASSESSED_JOURNEY]: ID_CHECK_CAN_NOT_DONE,
      [EXISTING_JOURNEY]: ID_CHECK_CAN_NOT_DONE
    }
  },
  {
    id: 'TSK-03',
    uri: 'task://lsap/verify/challenge?caseId={ReferenceID}',
    routePath: {
      [NTB_JOURNEY]: CHECKING_YOUR_IDENTITY,
      [PRE_ASSESSED_JOURNEY]: CHECKING_YOUR_IDENTITY,
      [EXISTING_JOURNEY]: CHECKING_YOUR_IDENTITY
    }
  },
  {
    id: 'TSK-04',
    uri: 'task://lsap/decline?caseId={ReferenceID}&reason=creditcheckdeclined',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_DECLINE,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_DECLINE,
      [EXISTING_JOURNEY]: CREDIT_CHECK_DECLINE
    }
  },
  {
    id: 'TSK-05',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferred',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED
    }
  },
  {
    id: 'TSK-06',
    uri: 'task://lsap/offer?caseId={ReferenceID}',
    routePath: {
      [NTB_JOURNEY]: YOUR_LOAN_APPROVAL,
      [PRE_ASSESSED_JOURNEY]: YOUR_LOAN_APPROVAL,
      [EXISTING_JOURNEY]: YOUR_LOAN_APPROVAL
    }
  },
  {
    id: 'TSK-07',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=fulfillmentinprogress',
    routePath: {
      [NTB_JOURNEY]: CONGRATULATIONS,
      [PRE_ASSESSED_JOURNEY]: CONGRATULATIONS,
      [EXISTING_JOURNEY]: CONGRATULATIONS
    }
  },
  {
    id: 'TSK-08',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=productsetupexception',
    routePath: {
      [NTB_JOURNEY]: CONGRATULATIONS,
      [PRE_ASSESSED_JOURNEY]: CONGRATULATIONS,
      [EXISTING_JOURNEY]: CONGRATULATIONS
    }
  },
  {
    id: 'TSK-09',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=applicationexpired',
    routePath: {
      [NTB_JOURNEY]: YOUR_LOAN_OPTIONS,
      [PRE_ASSESSED_JOURNEY]: INFORM_CHOICE,
      [EXISTING_JOURNEY]: INFORM_CHOICE
    }
  },
  {
    id: 'TSK-10',
    uri: 'task://lsap/cancelled?caseId={ReferenceID}',
    routePath: {
      [NTB_JOURNEY]: YOUR_LOAN_OPTIONS,
      [PRE_ASSESSED_JOURNEY]: INFORM_CHOICE,
      [EXISTING_JOURNEY]: INFORM_CHOICE
    }
  },
  {
    id: 'TSK-11',
    uri: 'task://lsap/cancelled?caseId={ReferenceID}&reason=applicationrejected',
    routePath: {
      [NTB_JOURNEY]: YOUR_LOAN_OPTIONS,
      [PRE_ASSESSED_JOURNEY]: INFORM_CHOICE,
      [EXISTING_JOURNEY]: INFORM_CHOICE
    }
  },
  {
    id: 'TSK-12',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=ConfirmCode',
    routePath: {
      [NTB_JOURNEY]: CONFIRM_CODE,
      [PRE_ASSESSED_JOURNEY]: CONFIRM_CODE,
      [EXISTING_JOURNEY]: CONFIRM_CODE
    }
  },
  {
    id: 'TSK-13',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferredpoi',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED_POI,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED_POI,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED_POI
    }
  },
  {
    id: 'TSK-14',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=ConfirmAuthCode',
    routePath: {
      [NTB_JOURNEY]: CONFIRM_AUTH_CODE,
      [PRE_ASSESSED_JOURNEY]: CONFIRM_AUTH_CODE,
      [EXISTING_JOURNEY]: CONFIRM_AUTH_CODE
    }
  },
  {
    id: 'TSK-15',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=productsetupinprogress',
    routePath: {
      [NTB_JOURNEY]: CONGRATULATIONS,
      [PRE_ASSESSED_JOURNEY]: CONGRATULATIONS,
      [EXISTING_JOURNEY]: CONGRATULATIONS
    }
  },
  {
    id: 'TSK-16',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckTACReferred',
    routePath: {
      [NTB_JOURNEY]: ERROR,
      [PRE_ASSESSED_JOURNEY]: ERROR,
      [EXISTING_JOURNEY]: ERROR
    }
  },
  {
    id: 'TSK-17',
    uri: 'task://lsap/decline?caseId={ReferenceID}&reason=idCheckfail',
    routePath: {
      [NTB_JOURNEY]: ERROR,
      [PRE_ASSESSED_JOURNEY]: ERROR,
      [EXISTING_JOURNEY]: ERROR
    }
  },
  {
    id: 'TSK-18',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferredBankCheck',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK
    }
  },
  {
    id: 'TSK-19',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferredNomatch',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED_NO_MATCH,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED_NO_MATCH,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED_NO_MATCH
    }
  },
  {
    id: 'TSK-20',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferredBankCheckPOI',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI
    }
  },
  {
    id: 'TSK-21',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=penddocsrcv',
    routePath: {
      [NTB_JOURNEY]: DOCUMENTS_ON_WAY,
      [PRE_ASSESSED_JOURNEY]: DOCUMENTS_ON_WAY,
      [EXISTING_JOURNEY]: DOCUMENTS_ON_WAY
    }
  }, // when customer request loan documents, and on get next task redirect to GET IN TOUCH SCREEN.
  {
    id: 'TSK-22',
    uri: 'task://lsap/verify/joint/challenge?caseId={ReferenceID}',
    routePath: {
      [NTB_JOURNEY]: JOINT_APPLICATION_SUBMISSION,
      [PRE_ASSESSED_JOURNEY]: JOINT_APPLICATION_SUBMISSION,
      [EXISTING_JOURNEY]: JOINT_APPLICATION_SUBMISSION
    }
  }, // JOINT APPLICATION IDV MATCH TASK URI
  {
    id: 'TSK-23',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=pendproddec',
    routePath: {
      [NTB_JOURNEY]: JOINT_APPLICATION_SUBMISSION,
      [PRE_ASSESSED_JOURNEY]: JOINT_APPLICATION_SUBMISSION,
      [EXISTING_JOURNEY]: JOINT_APPLICATION_SUBMISSION
    }
  }, // JOINT APPLICATION IDV MATCH TASK URI
  {
    id: 'TSK-24',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=pendotherpartyref',
    routePath: {
      [NTB_JOURNEY]: SUBMISSION_HOLDING_SCREEN,
      [PRE_ASSESSED_JOURNEY]: SUBMISSION_HOLDING_SCREEN,
      [EXISTING_JOURNEY]: SUBMISSION_HOLDING_SCREEN
    }
  }, // JOINT APPLICATION PENDING OTHER PART REF
  {
    id: 'TSK-25',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=creditcheckReferredNomatchPOI',
    routePath: {
      [NTB_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
      [PRE_ASSESSED_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
      [EXISTING_JOURNEY]: CREDIT_CHECK_REFERRED_BANK_CHECK_POI
    }
  }, // JOINT APPLICATION - IDV failed and POI
  {
    id: 'TSK-26',
    uri: 'task://lsap/decline?caseId={ReferenceID}&reason=idCheckDecline',
    routePath: {
      [NTB_JOURNEY]: NTB_DIP_IDV_DECLINE
    }
  }, // NTB APPLICATION IDENTITY CHECK DECLINE
  {
    id: 'TSK-27',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=PendingHooYu',
    routePath: {
      [NTB_JOURNEY]: NTB_DIP_DECLARATION_AND_AUTHORISATION
    }
  }, // NTB APPLICATION IDENTITY CHECK
  {
    id: 'TSK-28',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=PendingHooYu',
    routePath: {
      [NTB_JOURNEY]: NTB_DIP_KEEPING_YOU_SAFE
    }
  }, // NTB APPLICATION IDENTITY CHECK DECLINE
  {
    id: 'TSK-29',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=HooYuRefer',
    routePath: { [NTB_JOURNEY]: CREDIT_CHECK_REFERRED }
  }, //HOOYU REFER RESPONSE
  {
    id: 'TSK-30',
    uri: 'task://lsap/hold?caseId={ReferenceID}&reason=PendingHooYuNoLinkReceived',
    routePath: {
      [NTB_JOURNEY]: NTB_DIP_DECLARATION_AND_AUTHORISATION
    }
  } // NTB APPLICATION MITEK CURRENTLY UNAVIALABLE
];

const nextRouteTask = (caseId, uri, taskId) => {
  let task;
  let taskUrl = new URL(uri);
  const mitekUrl = taskUrl.searchParams.get('url');
  if (mitekUrl) {
    /*
     * when the mitekUrl is being sent down as a url param, an existing URI is used,
     * we can't use URI to uniquely identify the task in this case, so we need to use the ID
     */
    task = taskUrls.find((url) => url.id === taskId);
    task.mitekUrl = mitekUrl;
  } else {
    task = taskUrls.find((url) => url.uri.replace('{ReferenceID}', caseId) === uri);
  }
  return task;
};

export { nextRouteTask };
